export const getConfig = () => ({
  'Content-Type': 'application/json',
  headers: { Authorization: `JWT ${localStorage.getItem('token')}` }
});
